import { useState, useEffect } from "react";
import style from "./Backoffice-EquipmentImages.module.css";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { useData, useAddData, useDeleteData } from "../../../../hooks/api";

const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = error => reject(error);
  });
};

export const BackofficeEquipmentImages = () => {
  const [selectedFile, setSelectedFile] = useState(null);

  const { data: images, isLoading: isLoadingImages, error: errorImages } = useData("galeriaEquipamientos");
  const addImageMutation = useAddData("galeriaEquipamientos");
  const deleteImageMutation = useDeleteData("galeriaEquipamientos");

  const handleImages = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const uploadImageAsPromise = async (uploadFile) => {
    const { img, name } = uploadFile;

    const base64File = await fileToBase64(img);
    const formData = {
      fileContent: base64File,
      fileName: name,
    };

    addImageMutation.mutate(formData, {
      onSuccess: () => {
        setSelectedFile(null);
      },
      onError: (error) => {
        console.error("Error al subir la imagen:", error);
      }
    });
  };

  const addFile = () => {
    if (selectedFile) {
      uploadImageAsPromise({
        img: selectedFile,
        name: selectedFile.name,
      });
    }
  };

  const deleteImages = (id) => {
    deleteImageMutation.mutate(id, {
      onError: (error) => {
        console.error("Error al eliminar la imagen:", error);
      }
    });
  };

  const open = () => {
    document.getElementById("file").click();
  };

  useEffect(() => {
    if (selectedFile) {
      addFile();
    }
  }, [selectedFile]);

  if (isLoadingImages) {
    return <div>Cargando...</div>;
  }

  if (errorImages) {
    return <div>Error al cargar las imágenes: {errorImages.message}</div>;
  }

  return (
    <div className={style.container}>
      <div className={style.inputImgContainer}>
        <label htmlFor="">Cargar nueva imagen </label>
        <AddPhotoAlternateIcon
          className={style.iconElement}
          onClick={open}
        />
        <input
          className={style.inputImg}
          onChange={handleImages}
          type="file"
          id="file"
          style={{ display: 'none' }}
        />
      </div>
      <div className={style.imageContainer}>
        {images &&
          images.map((element, index) => (
            <div className={style.imgContainerMap} key={index}>
              <CancelRoundedIcon
                className={style.cancelIcon}
                onClick={() => deleteImages(element.id)}
              />
              <img src={`${element.img}`} alt={element.name} />
            </div>
          ))}
      </div>
    </div>
  );
};
